var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"phome u-bg-color--brand-black"},[_c('div',{staticClass:"phome__screen-container"},[_c('pf-content-centered',{attrs:{"content":_vm.content.lines}}),_c('pf-content-freelance',{attrs:{"item":_vm.content.freelance}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }